import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@shared/auth';
import { AppRoute, SharedPerm } from '@shared/constants';
import { stashAuthReturnUrl } from '@shared/utils';

/**
 * Allows non-installation contractors to access Supplier Management.
 */
export const canSeeContractorSupplierManagementGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const user = authService.user();

  if (!user.isInitialized) {
    stashAuthReturnUrl(state.url);
    router.navigate([AppRoute.Loading]);
    return false;
  }

  return user.hasPermission(SharedPerm.IsContractor) && !user.hasPermission(SharedPerm.IsInstallationContractor);
};
